import React from 'react';
import { ErrorMessage } from './elements';

const ErrorMessageCmp = ({ className, isVisible, message }) =>
  isVisible ? <ErrorMessage className={className}>{message}</ErrorMessage> : null;

export default ErrorMessageCmp;
